// Helpers PUROS de metadata/guardado del power plant (sin Konva ni `this`). Operan sobre
// `parts` (= powerPlant.parts: [{ pictogram_id, metadata:{ [view]:{x,y,rotation}, default } }]).
// Aíslan la lógica de negocio del motor de render para la migración futura a Three.js.

const ZERO_POS = { x: 0, y: 0, rotation: 0 }

// Posición/rotación persistida de un pictograma para una vista: la de la vista pedida,
// si no la 'default', si no cero. Devuelve null si el part existe pero no tiene metadata.
export function getPartMetadata(parts, pictogramId, type) {
  if (!parts) return { ...ZERO_POS }

  const part = parts.find(x => x.pictogram_id == pictogramId)
  if (part == null || part.metadata == null) return null

  if (part.metadata[type]) {
    return {
      x: part.metadata[type].x,
      y: part.metadata[type].y,
      rotation: part.metadata[type].rotation,
    }
  }

  if (part.metadata['default']) {
    return {
      x: part.metadata['default'].x,
      y: part.metadata['default'].y,
      rotation: part.metadata['default'].rotation,
    }
  }

  return { ...ZERO_POS }
}

// Escribe la posición actual de un part para una vista (y la replica en 'default').
export function writePartPosition(part, type, pos) {
  if (!part) return
  if (!part.metadata) part.metadata = {}
  part.metadata[type] = pos
  part.metadata['default'] = { ...pos }
}

// Construye/actualiza `parts` con lo enviado al backend (que no devuelve los parts):
// merge de metadata si el part existe, o alta local si es nuevo. Devuelve el array
// resultante (lo crea si venía null) y lo muta in situ cuando ya existe.
export function buildPartsFromSaveData(parts, dataPictograms) {
  const result = parts || []

  for (const picData of dataPictograms) {
    const picId = parseInt(picData.id)
    const part = result.find(p => p.pictogram_id == picId)

    if (part) {
      if (!part.metadata) part.metadata = {}
      Object.assign(part.metadata, picData.metadata)
    } else {
      result.push({
        pictogram_id: picId,
        metadata: { ...picData.metadata },
      })
    }
  }

  return result
}
